/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
  currentModal: null,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
  showModal({commit}, id) {
    commit("showModal", id);
  },

  hideModal({commit}) {
    commit("hideModal");
  },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
  showModal(state, id) {
    state.currentModal = id;

    window.Events.dispatch("modal.shown", id);
  },

  hideModal(state) {
    const id = state.currentModal;

    state.currentModal = null;

    window.Events.dispatch("modal.hidden", id);
  },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const modal = {
  namespaced: true,
  actions,
  mutations,
  state,
};
